module.exports = __webpack_public_path__ + "static/media/profile.98e33e48.jpg";